<div class="system-management">
  <div class="top-section">
    <!-- カレンダーウィジェット -->
    <div class="calendar-widget">
      <div class="calendar-header">
        <button (click)="previousMonth()" class="calendar-nav-btn">◀</button>
        <span class="calendar-title">{{ currentCalendarYear }}年 {{ currentCalendarMonth }}月</span>
        <button (click)="nextMonth()" class="calendar-nav-btn">▶</button>
      </div>
      <div class="calendar-grid">
        <div class="calendar-weekday">日</div>
        <div class="calendar-weekday">月</div>
        <div class="calendar-weekday">火</div>
        <div class="calendar-weekday">水</div>
        <div class="calendar-weekday">木</div>
        <div class="calendar-weekday">金</div>
        <div class="calendar-weekday">土</div>

        <div *ngFor="let day of calendarDays" class="calendar-day"
          [class.today]="day.isToday"
          [class.sunday]="day.isSunday"
          [class.saturday]="day.isSaturday"
          [class.other-month]="day.isOtherMonth"
          [style.background-color]="day.isReminder ? '#FFFF99' : ''"
          [style.border]="day.isHoliday ? '2px solid red' : ''">
          <span class="day-number" [style.color]="day.isOtherMonth ? '#ccc' : ''">{{ day.day }}</span>
        </div>
      </div>
    </div>

    <!-- システム設定 -->
    <div class="system-settings-form">
      <h3>システム設定</h3>

      <div class="form-row">
        <label for="alertMailAddress">アラート送信先</label>
        <input type="text" id="alertMailAddress" [(ngModel)]="alertMailAddress" class="form-control">
      </div>

      <div class="form-row">
        <label for="supportMailAddress">サポート送信先</label>
        <input type="text" id="supportMailAddress" [(ngModel)]="supportMailAddress" class="form-control">
      </div>

      <div class="form-row">
        <label for="defaultPassword">初期パスワード</label>
        <input type="text" id="defaultPassword" [(ngModel)]="defaultPassword" class="form-control">
      </div>

      <div class="form-row">
        <label for="passwordExpireDay">パスワード有効期間(日)</label>
        <input type="number" id="passwordExpireDay" [(ngModel)]="passwordExpireDay" class="form-control" min="1">
      </div>

      <div class="form-row">
        <label for="passwordExpireWarningDay">パスワード有効期間予告(日)</label>
        <input type="number" id="passwordExpireWarningDay" [(ngModel)]="passwordExpireWarningDay" class="form-control" min="1">
      </div>

      <div class="button-group">
        <button (click)="saveSystemSettings()" class="btn btn-primary">保存</button>
        <button (click)="resetSystemSettings()" class="btn btn-secondary">リセット</button>
      </div>
    </div>
  </div>

  <div class="bottom-section">
    <!-- 祝日登録 -->
    <div class="holiday-registration">
      <h3>祝日登録</h3>
      <p>１年分の祝日を入力し、「登録」ボタンを押してください。<br />対象年度の祝日が既に登録されている場合は完全差替えとなります。</p>
      <div class="holiday-content">
        <!-- 対象年エリア -->
        <div class="year-area">
          <label>対象年</label>
          <select [(ngModel)]="holidayYear" (change)="onHolidayYearChange()" class="form-control">
            <option *ngFor="let year of holidayYearOptions" [value]="year">{{ year }}年</option>
          </select>
          <div class="holiday-list">
            <div *ngFor="let holiday of holidayList" class="holiday-item">
              {{ formatHolidayDate(holiday.date) }}
            </div>
            <div *ngIf="holidayList.length === 0" class="no-data">
              登録なし
            </div>
          </div>
        </div>

        <!-- 祝日入力エリア -->
        <div class="input-area">
          <label>祝日入力</label>
          <textarea [(ngModel)]="holidayInputText" rows="20" class="form-control"></textarea>
          <button (click)="saveHolidays()" class="btn btn-primary">登録</button>
        </div>

        <!-- 入力例エリア -->
        <div class="example-area">
          <label>入力例</label>
          <div class="example-text">
            2024/1/1<br>
            2024/1/8<br>
            2024/2/11<br>
            2024/2/12<br>
            2024/2/23<br>
            ：<br>
          </div>
        </div>
      </div>
    </div>

    <!-- リマインド日登録 -->
    <div class="reminder-registration">
      <h3>リマインド日登録</h3>
      <p>１年分のリマインド日をまとめて登録するか、または特定の箇所を修正して更新してください。</p>
      <div class="reminder-content">
        <!-- 対象年とリマインド日表示 -->
        <div class="year-area">
          <div class="year-selector">
            <label for="reminderYear">対象年</label>
            <select id="reminderYear" [(ngModel)]="reminderYear" (change)="onReminderYearChange()" class="form-control">
              <option *ngFor="let year of reminderYearOptions" [ngValue]="year">{{ year }}年</option>
            </select>
          </div>

          <div class="reminder-grid">
            <table class="reminder-table">
              <thead>
                <tr>
                  <th>月</th>
                  <th>末締第１営</th>
                  <th>末締第２営</th>
                  <th>中締第１営</th>
                  <th>中締第２営</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let month of reminderMonths">
                  <td class="month-cell">{{ month.month }}</td>
                  <td><input type="text" [(ngModel)]="month.day1" placeholder="MM/DD" class="reminder-input"></td>
                  <td><input type="text" [(ngModel)]="month.day2" placeholder="MM/DD" class="reminder-input"></td>
                  <td><input type="text" [(ngModel)]="month.day3" placeholder="MM/DD" class="reminder-input"></td>
                  <td><input type="text" [(ngModel)]="month.day4" placeholder="MM/DD" class="reminder-input"></td>
                </tr>
              </tbody>
            </table>
            <button (click)="updateReminders()" class="btn btn-primary update-btn">更新</button>
          </div>
        </div>

        <!-- リマインド日入力 -->
        <div class="input-area">
          <label for="reminderInput">リマインド日入力</label>
          <textarea id="reminderInput" [(ngModel)]="reminderInputText" rows="20" class="form-control"></textarea>
          <button (click)="saveReminders()" class="btn btn-primary">登録</button>
        </div>
      </div>
    </div>
  </div>
</div>
